import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'components/ui';
import {Link} from 'react-router-dom';
import styles from './ViewHeader.module.scss';

export interface CompositionFeedbackHeaderProps {
  title: string;
  subtitle: string;
  path: string;
  hasScrollShadow?: boolean;
  toggleWriteToReWrite: () => void;
  showTransitionButtons?: boolean;
  activeWriting?: string;
}

function ViewHeader({
  title,
  path,
  hasScrollShadow,
  subtitle,
  toggleWriteToReWrite,
  showTransitionButtons,
  activeWriting,
}: CompositionFeedbackHeaderProps): JSX.Element {
  const isActiveWriting = activeWriting === 'activeWriting';
  const isActiveRewriting = activeWriting === 'activeRewriting';

  return (
    <header
      data-testid="composition-feedback-header"
      data-has-scroll-shadow={hasScrollShadow}
      className={styles.header}
    >
      <Link to={path} aria-label="Voltar">
        <FontAwesomeIcon icon="arrow-left" />
      </Link>

      <div className={styles.contentWrapper}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          <h3 className={styles.subtitle}>{subtitle}</h3>
        </div>

        {showTransitionButtons && (
          <div className={styles.transitionButtons}>
            <Button
              text="Escrita"
              onClick={isActiveWriting ? undefined : toggleWriteToReWrite}
              type="button"
              variant={isActiveWriting ? 'primary' : 'secondary'}
              size="medium"
              borderColor="transparent"
              textColor="black"
            />
            <Button
              text="Reescrita"
              onClick={isActiveRewriting ? undefined : toggleWriteToReWrite}
              type="button"
              variant={isActiveRewriting ? 'primary' : 'secondary'}
              size="medium"
              borderColor="transparent"
            />
          </div>
        )}
      </div>
    </header>
  );
}

export default ViewHeader;
